export enum OrderPadState {
    SELL,
    BUY
}